/** @jsx jsx */
import { jsx } from '@emotion/react'
import { useState } from 'react'

import { PrimaryButton, SecondaryButton } from '../../../shared/buttons'
import { ButtonType } from '../../../shared/buttons/types'
import { RadioGroup } from '../../../shared/input'
import { RadioItem } from '../../../shared/input/Radio/Radio'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../../../shared/modal'
import { ModalSize } from '../../../shared/modal/Modal/Modal'

type MarkCommentsAsReadModalProps = {
  /** Indicates if the modal is open */
  isOpen: boolean
  /** Event callback when user triggers a close event (eg. button click or ESC key) */
  onCancel: () => void
  /** Event callback when the save (add) comment button is clicked */
  onSave: (selectedOption: string) => void
  /** Indicates if the modal is open */
  selectedStudentsCount: number
  /** Indicates if the modal is open */
  allStudentsCount: number
}

const MarkCommentsAsReadModal = ({
  isOpen,
  onCancel,
  onSave,
  selectedStudentsCount,
  allStudentsCount
}: MarkCommentsAsReadModalProps) => {
  const [selectedOption, setSelectedOption] = useState<string>('selected')

  const onSubmitModal = (e: React.FormEvent) => {
    e.preventDefault()
    onSave(selectedOption)
  }

  const handleSelectedOptionChange = (value: string) => {
    setSelectedOption(value)
  }

  const markOptions: RadioItem[] = [
    {
      label: `Mark comments as read for the selected students (${selectedStudentsCount})`,
      value: 'selected'
    },
    {
      label: `Mark comments as read for all students (${allStudentsCount})`,
      value: 'all'
    }
  ]
  return (
    <Modal allowMobilePage isOpen={isOpen} size={ModalSize.SM} onSubmit={onSubmitModal}>
      <ModalHeader allowMobile onClose={onCancel} title="Mark Comments as Read" />
      <ModalBody allowMobile>
        <RadioGroup
          ariaLabel="Select a report type."
          options={markOptions}
          onChange={handleSelectedOptionChange}
          selectedOption={selectedOption}
        />
      </ModalBody>
      <ModalFooter>
        <SecondaryButton onClick={onCancel}>Cancel</SecondaryButton>
        <PrimaryButton
          disabled={selectedOption === 'selected' && selectedStudentsCount <= 0}
          type={ButtonType.Submit}
        >
          Continue
        </PrimaryButton>
      </ModalFooter>
    </Modal>
  )
}

export default MarkCommentsAsReadModal
